import {
    State,
    initialState,
} from "@/mk2/apps/bazaar/containers/SellExperiencePopup/SellExperiencePopup.reducers";
import { AppState } from "@/mk2/reducers";

export const getSellExperiencePopupState = (state: AppState): State =>
    state.containers.bazaar.sellExperiencePopup || initialState;
